import React from 'react';

import { Chip } from '@material-ui/core';

import styles from './JobAlertChip.module.scss';

export type JobAlertChipProps = {
  label: string;
};

const JobAlertChip = ({ label }: JobAlertChipProps) => {
  return (
    <span className={styles.container}>
      <Chip label={label} color={'primary'} variant={'outlined'} className={styles.chip} />
    </span>
  );
};

export default JobAlertChip;
